import Splide from '@splidejs/splide';
import {
  Grid
} from '@splidejs/splide-extension-grid';



const sliderSections = document.querySelectorAll(".s-posts-slide");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-posts-slide__slider");

  const sliderSettings = {
    pagination: false,
    perPage: 3,
    perMove: 1,
    gap: 16,
    grid: {
      gap: {
        row: 16,
        col: 0,
      },
      dimensions: [
        [1, 1],
        [2, 1]
      ]
    },
    breakpoints: {
      1500: {
        perPage: 2,
      },
      990: {
        grid: false,
        autoWidth: true,
      },
      600: {
        perPage: 1,
      },
    },
  };

  new Splide(slider, sliderSettings).mount({
    Grid
  });
});
